import { render, staticRenderFns } from "./logoBlueMobile.vue?vue&type=template&id=563fd8ec&"
import script from "./logoBlueMobile.vue?vue&type=script&lang=js&"
export * from "./logoBlueMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports